import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './pages.css';
import { FaShieldAlt, FaUserLock } from 'react-icons/fa';

const PrivacyPolicy = () => {
  return (
    <Container className="privacy-policy py-5">
      <Row className="justify-content-center">
        <Col lg={10} xl={8}>
          <div className="text-center mb-5">
            <h1 className="display-4 mb-3 text-danger">
              <FaShieldAlt className="me-2" />
              Privacy Policy
            </h1>
            <p className="lead">Last Updated: {new Date().toLocaleDateString()}</p>
          </div>

          <div className="policy-card p-4 p-md-5 mb-5">
            <h2 className="h4 mb-4 text-danger">
              <FaUserLock className="me-2" />
              Your Privacy Matters
            </h2>
            <p>
              At Noureesh Foods, we're committed to protecting your personal information. This policy explains how we collect, use, and safeguard your data when you use our website and services.
            </p>
          </div>

          <div className="mb-5">
            <h2 className="h3 mb-4 border-bottom pb-2">1. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul className="styled-list">
              <li><strong>Personal Information:</strong> Name, email, phone number, delivery address when you place an order</li>
              <li><strong>Payment Information:</strong> Processed securely through our payment partners (we don't store credit card details)</li>
              <li><strong>Usage Data:</strong> How you interact with our website (cookies, IP address, browser type)</li>
              <li><strong>Communication Data:</strong> Messages you send through contact forms or customer service</li>
            </ul>
          </div>

          <div className="mb-5">
            <h2 className="h3 mb-4 border-bottom pb-2">2. How We Use Your Information</h2>
            <p>We use your data to:</p>
            <div className="d-flex flex-wrap gap-3 mb-4">
              <div className="usage-card p-3">
                <div className="icon-circle bg-danger text-white mb-2">
                  <i className="fas fa-shipping-fast"></i>
                </div>
                <h4 className="h6">Order Fulfillment</h4>
                <p className="small">Process and deliver your delicious orders</p>
              </div>
              <div className="usage-card p-3">
                <div className="icon-circle bg-danger text-white mb-2">
                  <i className="fas fa-envelope"></i>
                </div>
                <h4 className="h6">Communication</h4>
                <p className="small">Send order confirmations and updates</p>
              </div>
              <div className="usage-card p-3">
                <div className="icon-circle bg-danger text-white mb-2">
                  <i className="fas fa-chart-line"></i>
                </div>
                <h4 className="h6">Improvements</h4>
                <p className="small">Enhance our website and services</p>
              </div>
            </div>
          </div>

          <div className="mb-5">
            <h2 className="h3 mb-4 border-bottom pb-2">
              3. Cookies & Tracking
            </h2>
            <p>We use cookies to:</p>
            <ul className="styled-list">
              <li>Remember your preferences and shopping cart</li>
              <li>Analyze website traffic and performance</li>
              <li>Enable social media features</li>
            </ul>
            <div className="alert alert-light mt-4">
              <p className="mb-0">You can control cookies through your browser settings. Disabling them may affect website functionality.</p>
            </div>
          </div>

          <div className="mb-5">
            <h2 className="h3 mb-4 border-bottom pb-2">4. Data Security</h2>
            <p>We implement:</p>
            <div className="security-features row g-3">
              <Col md={6}>
                <div className="security-card h-100 p-3">
                  <h4 className="h6 text-danger">SSL Encryption</h4>
                  <p>All data transfers are encrypted with industry-standard SSL technology</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="security-card h-100 p-3">
                  <h4 className="h6 text-danger">Access Controls</h4>
                  <p>Strict employee access restrictions to your data</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="security-card h-100 p-3">
                  <h4 className="h6 text-danger">Regular Audits</h4>
                  <p>Frequent security assessments of our systems</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="security-card h-100 p-3">
                  <h4 className="h6 text-danger">Secure Payments</h4>
                  <p>PCI-DSS compliant payment processing</p>
                </div>
              </Col>
            </div>
          </div>

          <div className="mb-5">
            <h2 className="h3 mb-4 border-bottom pb-2">5. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="rights-list">
              <li>Access your personal data we hold</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your data (where applicable)</li>
              <li>Opt-out of marketing communications</li>
              <li>Lodge complaints with data protection authorities</li>
            </ul>
            <p className="mt-3">
              To exercise these rights, please contact us at <a href="mailto:privacy@noureeshfoods.com" className="text-danger">privacy@noureeshfoods.com</a>
            </p>
          </div>

          <div className="policy-updates bg-light p-4 rounded">
            <h3 className="h5 text-danger">Policy Updates</h3>
            <p>
              We may update this policy periodically. Significant changes will be notified through our website or email. Continued use of our services constitutes acceptance of the updated policy.
            </p>
          </div>

          <div className="contact-box mt-5 p-4 border border-danger rounded text-center">
            <h3 className="h5 text-danger">Questions?</h3>
            <p className="mb-2">Contact our Data Protection Officer:</p>
            <p className="mb-1">
              <a href="mailto:dpo@noureeshfoods.com" className="text-danger">dpo@noureeshfoods.com</a>
            </p>
            <p>+234 812 345 6789</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;